/**
 * @generated SignedSource<<a06facddcd56e7c31e43885ac6eb80b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly fieldSetId: string | null | undefined;
      readonly fields: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: string;
            readonly fieldId: string;
            readonly isEditableInIssueView?: boolean | null | undefined;
            readonly type: string;
            readonly " $fragmentSpreads": FragmentRefs<"affectedServices_nativeIssueTable_AffectedServicesCell" | "cmdbObjects_nativeIssueTable_CmdbObjectsCell" | "components_nativeIssueTable_ComponentsCell" | "date_nativeIssueTable_DateCell" | "epicLink_nativeIssueTable_EpicLinkCell" | "fallback_nativeIssueTable_FallbackCell" | "issueKey_nativeIssueTable_IssueKeyCell" | "issueLinks_nativeIssueTable_IssueLinksCell" | "issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell" | "issueStatus_nativeIssueTable_IssueStatusCell" | "issueSummary_nativeIssueTable_IssueSummaryCell" | "issueType_nativeIssueTable_IssueTypeCell" | "labels_nativeIssueTable_LabelsCell" | "parent_nativeIssueTable_ParentCell" | "plainText_nativeIssueTable_PlainTextCell" | "priority_nativeIssueTable_PriorityCell" | "project_nativeIssueTable_ProjectCell" | "requestType_nativeIssueTable_RequestTypeCell" | "resolution_nativeIssueTable_ResolutionCell" | "richText_nativeIssueTable_RichTextCell" | "sprint_nativeIssueTable_SprintCell" | "user_nativeIssueTable_UserCell_fieldRef" | "versions_nativeIssueTable_VersionsCell">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView";
};
export type issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView$key = {
  readonly " $data"?: issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "type"
},
v1 = [
  {
    "kind": "Variable",
    "name": "isInlineEditingEnabled",
    "variableName": "isInlineEditingEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isEditableReadsEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView",
  "selections": [
    {
      "concreteType": "JiraIssueFieldSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "fieldSetId"
            },
            {
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fields",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "__typename"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fieldId"
                        },
                        (v0/*: any*/),
                        {
                          "condition": "isEditableReadsEnabled",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "isEditableInIssueView"
                            }
                          ]
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "affectedServices_nativeIssueTable_AffectedServicesCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "cmdbObjects_nativeIssueTable_CmdbObjectsCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "components_nativeIssueTable_ComponentsCell"
                        },
                        {
                          "args": (v1/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "date_nativeIssueTable_DateCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "epicLink_nativeIssueTable_EpicLinkCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "fallback_nativeIssueTable_FallbackCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "issueKey_nativeIssueTable_IssueKeyCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell"
                        },
                        {
                          "args": (v1/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "issueStatus_nativeIssueTable_IssueStatusCell"
                        },
                        {
                          "args": (v1/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "issueSummary_nativeIssueTable_IssueSummaryCell"
                        },
                        {
                          "args": (v1/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "labels_nativeIssueTable_LabelsCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "issueType_nativeIssueTable_IssueTypeCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "parent_nativeIssueTable_ParentCell"
                        },
                        {
                          "args": (v1/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "priority_nativeIssueTable_PriorityCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "project_nativeIssueTable_ProjectCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "resolution_nativeIssueTable_ResolutionCell"
                        },
                        {
                          "args": (v1/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "sprint_nativeIssueTable_SprintCell"
                        },
                        {
                          "args": (v1/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "user_nativeIssueTable_UserCell_fieldRef"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "versions_nativeIssueTable_VersionsCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "plainText_nativeIssueTable_PlainTextCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "richText_nativeIssueTable_RichTextCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "requestType_nativeIssueTable_RequestTypeCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "issueLinks_nativeIssueTable_IssueLinksCell"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueFieldSetConnection"
};
})();

(node as any).hash = "7759fd10379f94fe100a0676bd68bfce";

export default node;
